import moment from "moment"

export function formatDate(date?: any, format:string = "DD/MM/YYYY"): string {
  if(!date){
    return "Invalid Date"
  }
  return moment(date).format(format)
}
